import { render, staticRenderFns } from "./TributeLifeEvents.vue?vue&type=template&id=29557ad5&scoped=true"
import script from "./TributeLifeEvents.vue?vue&type=script&lang=js"
export * from "./TributeLifeEvents.vue?vue&type=script&lang=js"
import style0 from "./TributeLifeEvents.vue?vue&type=style&index=0&id=29557ad5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29557ad5",
  null
  
)

export default component.exports